import { useEffect, useState } from "react";
import axios from "axios";
import { Star, Quote } from "lucide-react";
import { COMPANY } from "@/lib/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Stars = ({ n }) => (
  <div className="flex gap-0.5" aria-label={`${n} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map(i => (
      <Star key={i} className={`w-4 h-4 ${i <= n ? "text-[#FF5722] fill-[#FF5722]" : "text-white/20"}`} />
    ))}
  </div>
);

export const ReviewsBand = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios.get(`${API}/reviews`).then(({ data }) => setReviews(data || [])).catch(() => {});
  }, []);

  if (reviews.length === 0) return null;

  return (
    <section className="section px-6 lg:px-10 border-t border-white/10 bg-black" data-testid="reviews-band">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-12">
        <div className="lg:col-span-7">
          <div className="eyebrow mb-4">What Customers Say</div>
          <h2 className="font-display text-4xl md:text-6xl leading-[0.9] tracking-tighter">
            <span className="text-[#FF5722]">5-star</span> across the Southeast.
          </h2>
        </div>
        <div className="lg:col-span-5 lg:col-start-8 flex lg:justify-end items-center gap-4">
          <div className="flex flex-col items-end">
            <div className="flex items-center gap-2"><Stars n={5} /><span className="font-display text-xl">5.0</span></div>
            <div className="text-xs uppercase tracking-widest text-zinc-500 mt-1">{reviews.length}+ verified reviews</div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {reviews.slice(0, 6).map(r => (
          <blockquote key={r.id} className="border border-white/10 p-6 bg-[#0B0B0D] flex flex-col" data-testid={`review-${r.id}`}>
            <Quote className="w-6 h-6 text-[#FF5722] shrink-0" />
            <p className="mt-4 text-zinc-200 leading-relaxed flex-1">{r.quote}</p>
            <footer className="mt-6 pt-4 border-t border-white/10">
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-display text-lg tracking-tight">{r.author}</div>
                  <div className="text-xs uppercase tracking-widest text-zinc-500 mt-0.5">via {r.source}</div>
                </div>
                <Stars n={r.rating || 5} />
              </div>
            </footer>
          </blockquote>
        ))}
      </div>

      <div className="mt-10 flex flex-wrap items-center gap-4">
        <a href={`https://www.google.com/search?q=${encodeURIComponent(COMPANY.name + ' ' + COMPANY.city)}`} target="_blank" rel="noopener noreferrer" className="btn-ghost" data-testid="reviews-google-link">
          Read More on Google →
        </a>
        <span className="text-xs uppercase tracking-widest text-zinc-500">Fabricators · Restorers · GCs</span>
      </div>
    </section>
  );
};
